import { render, staticRenderFns } from "./MainContents.vue?vue&type=template&id=4cf2e152&scoped=true&"
import script from "./MainContents.vue?vue&type=script&lang=js&"
export * from "./MainContents.vue?vue&type=script&lang=js&"
import style0 from "./MainContents.vue?vue&type=style&index=0&id=4cf2e152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2e152",
  null
  
)

export default component.exports